// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201036/js/" + chunkId + "." + {"44":"d5e86779","225":"9ec9e152","481":"6eb2cf4c","486":"f146b3da","770":"eca696e4"}[chunkId] + ".0.33937938747003815.chunk.js";
};